import dateFormat, { masks } from "dateformat";
import ReactHtmlParser from "react-html-parser";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
function InquiryItemView(props) {
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "USD",
    }).format(value);
  return (
      <div className="timeline-item-v2-component-box">
        <div className="timeline-item-event-header-wrapper">
          <div class="icon-thumbnail-component timeline-item-icon">
            <CalendarMonthIcon />
          </div>
          <div class="timeline-item-date-wrapper">
            <div className="timeline-date-v2-component">
            {dateFormat(props.INSERT_DATE, "dd-mmm-yyyy h:MM:ss TT")}
            
            </div>
            
          </div>
        </div>
        <div className="timeline-item-content-wrapper2">
      
          <div className="timeline-item-header-title">
            {(() => {
        switch (props.STATUS_ID) {
          case "0":
            return <div className="Comment">{props.STATUS_NAME}</div>;
          case "1":
            return <div className="New">{props.STATUS_NAME}</div>;
          case "2":
            return <div className="Processing">{props.STATUS_NAME}</div>;
          case "3":
            return <div className="Done">{props.STATUS_NAME}</div>;
          case "4":
            return <div className="Reject">{props.STATUS_NAME}</div>;
          case "6":
            return <div className="Close">{props.STATUS_NAME}</div>;
          case "5":
            if((props.ATT1).trim() === 'Negative') {
            return ([
              <div className="Complete">{props.STATUS_NAME}</div>,
              <p className="red">{props.ATT1}</p>
            ]);
            }
            else{
              return ([
                <div className="Complete">{props.STATUS_NAME}</div>,
                <p className="greenText">{props.ATT1}</p>
              ]);
            }
  
          default:
            return <div className="Comment">{props.STATUS_NAME}</div>;
        }
      })()}
            <b>By: {props.USERID}</b>
          </div>
          <p>{ReactHtmlParser(props.COMMENT)}</p>
        </div>
      </div>
      
  );
}
export default InquiryItemView;
